import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgWorld = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 3.5a8.5 8.5 0 0 0-8.025 11.308h1.977a1.74 1.74 0 0 0 1.74-1.74v-2.135a3.24 3.24 0 0 1 3.24-3.24 1.74 1.74 0 0 0 1.741-1.741V3.526A9 9 0 0 0 12 3.5m0 17a8.5 8.5 0 0 1-7.33-4.192h1.282a3.24 3.24 0 0 0 3.24-3.24v-2.135a1.74 1.74 0 0 1 1.74-1.74 3.24 3.24 0 0 0 3.241-3.241V3.78a8.51 8.51 0 0 1 6.233 6.952 5.8 5.8 0 0 0-1.457-.193h-3.035a3.24 3.24 0 0 0 0 6.48 1.03 1.03 0 0 1 1.028 1.03v.867A8.46 8.46 0 0 1 12 20.5m6.401-2.907a8.47 8.47 0 0 0 2.093-5.256 4.3 4.3 0 0 0-1.552-.298h-3.028a1.74 1.74 0 1 0 0 3.48 2.53 2.53 0 0 1 2.487 2.074m3.598-5.701L22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2q.722 0 1.417.1h.006q.123 0 .233.037c4.672.778 8.248 4.795 8.342 9.665a1 1 0 0 1 .001.09"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgWorld;
